import axios from 'axios';
import React, { useEffect, useState } from 'react';
import '../assets/css/PollView.css';
import Swal from 'sweetalert2';
import { baseurl } from '../utility/helper';
import { useNavigate, Link } from "react-router-dom";
import defaultImage from "../assets/image/demo.jpeg";

const MemberForm = () => {
    const roleid = parseInt(sessionStorage.getItem("userroleId"));
    const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
    const [selectedChapter, setSelectedChapter] = useState(initialChapter);
    const navigate = useNavigate(); // Get navigate function
    const [joiningDate, setJoiningDate] = useState('');
    const [errors, setErrors] = useState({});
    const [expiryDate, setExpiryDate] = useState('');
    const [lastrenewalDate, setLastReneal] = useState(null);
    const [membersTerms, setMembersTerm] = useState('');
    const [selectedTerm, setSelectedTerm] = useState("");
    const [sameAsPresent, setSameAsPresent] = useState(false);
    const [options, setOptions] = useState([]);  // <-- Add this to store API data
    const [chapters, setChapter] = useState([]);  // <-- Add this to store API data
    const [profilePicFile, setProfilePicFile] = useState(defaultImage);
    const [isMembershipExists, setIsMembershipExists] = useState(false);
    const [presentAddress, setPresentAddress] = useState({
        address: '',
        city: '',
        state: '',
        pincode: ''
    });
    const [permanentAddress, setPermanentAddress] = useState({
        address: '',
        city: '',
        state: '',
        pincode: ''
    });
    
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        gender: '',
        dob: '',
        mobileNumber: '',
        membership_no: '',
        testDate: '',
        firstTestScore: '',
        firstTestName: '',
        secondTestScore: '',
        secondTestName: '',
        note: ''
    });

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await axios.get(`${baseurl}/admin/members/memberterms`);
                setOptions(response.data); // Store API data in 'options'
                // console.log("terms:", response.data);
            } catch (error) {
                console.error("Error fetching membership terms:", error);
            }
        };

        const fetchChapters = async () => {
            try {
                const response = await axios.get(`${baseurl}/admin/chapters`);
                setChapter(response.data); // Store API data in 'options'
                // console.log("terms:", response.data);
            } catch (error) {
                console.error("Error fetching chapters:", error);
            }
        };

        fetchOptions();
        fetchChapters();
    }, []); // Runs only once when the component mounts


    useEffect(() => {
    if (joiningDate && selectedTerm && options.length > 0) {
        const joinDate = new Date(joiningDate);
        const month = joinDate.getMonth() + 1; // 1–12
        const year = joinDate.getFullYear();

        let baseExpiryYear;

        // 🔹 Membership validity logic
        if (month >= 1 && month <= 9) {
        // Jan–Sep → next year March
        baseExpiryYear = year + 1;
        } else if (month >= 10 && month <= 12) {
        // Oct–Dec → year after next March
        baseExpiryYear = year + 2;
        }

        let expiryYear = baseExpiryYear;

        // 🔹 Membership term logic (till 31 March)
        if (selectedTerm === '2') {
        // 5 years
        expiryYear = baseExpiryYear + 4; // already includes first year
        } else if (selectedTerm === '3') {
        // 1 year
        expiryYear = baseExpiryYear;
        } else if (selectedTerm === '1') {
        // lifetime
        setExpiryDate("2125-03-31");
        return;
        }

        const expiry = new Date(expiryYear, 2, 31); // 31 March

        const yyyy = expiry.getFullYear();
        const mm = String(expiry.getMonth() + 1).padStart(2, '0');
        const dd = String(expiry.getDate()).padStart(2, '0');

        setExpiryDate(`${yyyy}-${mm}-${dd}`);
    }
    }, [joiningDate, selectedTerm, options]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfilePicFile(file); // Save actual file
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfilePicFile(reader.result); // For preview
            };
            reader.readAsDataURL(file);
        }
    };


    const handleEditClick = () => {
        document.getElementById('fileInput').click();
    };

    const handlePresentChange = async (e) => {
        const { id, value } = e.target;
        setPresentAddress((prevState) => ({
            ...prevState,
            [id]: value
        }));

        if (sameAsPresent) {
            setPermanentAddress((prevState) => ({
                ...prevState,
                [id]: value
            }));
        }
        
    };

    const handlePermanentChange = async (e) => {
        const { id, value } = e.target;
        setPermanentAddress((prevState) => ({
            ...prevState,
            [id]: value
        }));
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setSameAsPresent(isChecked);
        if (isChecked) {
            setPermanentAddress({ ...presentAddress });
        } else {
            setPermanentAddress({
                address: '',
                city: '',
                state: '',
                pincode: ''
            });
        }
    };

    const handleMobileBlur = async () => {
    const mobile = formData.mobileNumber;

    if (mobile.length === 10) {
        try {
            const response = await axios.get(`${baseurl}/admin/candidatedetail/${mobile}`);

            const data = response.data;
             // 🔹 Guard: if no data or no candidate, exit early
            if (!data || !data.candidate) return;

            const candidate = data.candidate;
            const tests = data.tests || []; // 🔹 Default to empty array if tests is undefined


            // Set formData
            setFormData((prev) => ({
                ...prev,
                firstName: data.candidate.firstName || '',
                lastName: data.candidate.lastName || '',
                email: data.candidate.email || '',
                gender: data.candidate.gender || '',
                dob: data.candidate.dob || '',
                testDate: data.tests[0]?.testDate || '',
                firstTestName: data.tests[0]?.testName || '',
                firstTestScore: data.tests[0]?.testScore || '',
                secondTestName: data.tests[1]?.testName || '',
                secondTestScore: data.tests[1]?.testScore || '',
            }));

            // Set Profile Pic
            if (data.candidate.candidate_img) {
                setProfilePicFile(data.candidate.candidate_img);
            }

            // Set Address
            if (data.candidate.address) {
                setPresentAddress({
                    address: data.candidate.address || '',
                    city: data.candidate.city || '',
                    state: data.candidate.state || '',
                    pincode: data.candidate.pincode || ''
                });
            }
            setSameAsPresent(data.sameAsPresent || false);

        } catch (error) {
            console.error("Error fetching member details:", error);
        }
    }
};


    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value
        }));
    };

    const handleCancel = (e) => {
        navigate('admin/MemberList'); // Navigate to Member List page
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation for required fields
        const newErrors = {};
        if (!formData.firstName) newErrors.firstName = "First name is required";
        if (!formData.lastName) newErrors.lastName = "Last name is required";
        // if (!formData.email) newErrors.email = "Email is required";
        if (!formData.gender) newErrors.gender = "Gender is required";
        if (!formData.dob) newErrors.dob = "Date of birth is required";
        if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile number is required";
        // if (!formData.testDate) newErrors.testDate = "Test date is required";
        // if (!formData.firstTestName) newErrors.firstTestName = "First test name is required";
        // if (!formData.firstTestScore) newErrors.firstTestScore = "First test score is required";
        // if (!formData.secondTestName) newErrors.secondTestName = "Second test name is required";
        // if (!formData.secondTestScore) newErrors.secondTestScore = "Second test score is required";
        // if (!formData.note) newErrors.note = "Note is required";
        if (!joiningDate) newErrors.joiningDate = "Joining date is required";
        if (!expiryDate) newErrors.expiryDate = "Expiry date is required";
        // if (!lastrenewalDate) newErrors.lastrenewalDate = "Last renewal date is required";
        if (!selectedTerm) newErrors.selectedTerm = "Members term is required";
        if (!selectedChapter) newErrors.selectedChapter = "Chapter is required";

        // if (!presentAddress.address) newErrors.presentAddress = "Present address is required";
        // if (!presentAddress.pincode) newErrors.presentPincode = "Present pincode is required";
        // if (!presentAddress.city) newErrors.presentCity = "Present city is required";
        // if (!presentAddress.state) newErrors.presentState = "Present state is required";

        // if (!permanentAddress.address) newErrors.permanentAddress = "Permanent address is required";
        // if (!permanentAddress.pincode) newErrors.permanentPincode = "Permanent pincode is required";
        // if (!permanentAddress.city) newErrors.permanentCity = "Permanent city is required";
        // if (!permanentAddress.state) newErrors.permanentState = "Permanent state is required";

        // If there are errors, set them and stop form submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        // Clear previous errors
        setErrors({});


        const formDataToSend = new FormData();
        if (profilePicFile !== defaultImage) {
            formDataToSend.append("profilePic", profilePicFile); // Make sure the backend expects "profilePic"
        }

        formDataToSend.append('firstName', formData.firstName);
        formDataToSend.append('lastName', formData.lastName);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('gender', formData.gender);
        if (formData.dob) {
            formDataToSend.append('dob', formData.dob);
        }
        formDataToSend.append('mobileNumber', formData.mobileNumber);
        formDataToSend.append('membership_no', formData.membership_no);
        formDataToSend.append('testDate', formData.testDate);
        formDataToSend.append('firstTestScore', formData.firstTestScore);
        formDataToSend.append('firstTestName', formData.firstTestName);
        formDataToSend.append('secondTestScore', formData.secondTestScore);
        formDataToSend.append('secondTestName', formData.secondTestName);
        formDataToSend.append('note', formData.note);
        formDataToSend.append('joiningDate', joiningDate);
        formDataToSend.append('expiryDate', expiryDate);
        if (lastrenewalDate) {
            formDataToSend.append('lastrenewal', lastrenewalDate);
        }
        formDataToSend.append('membersTerm', selectedTerm);
        formDataToSend.append('chapters', selectedChapter);
        formDataToSend.append('presentAddress', JSON.stringify(presentAddress));
        formDataToSend.append('permanentAddress', JSON.stringify(permanentAddress));
        formDataToSend.append('sameAsPresent', sameAsPresent || false);
        console.log('send data:', formDataToSend);
        try {
            const token = sessionStorage.getItem("token");
            const response = await axios.post(`${baseurl}/admin/member`, formDataToSend, {
                headers: {
                    'Authorization': `${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log('Response:', response.data);
            // Show SweetAlert after successful submission
            Swal.fire({
                title: 'Success!',
                text: 'Member Details submitted successfully!',
                icon: 'success',
                timer: 5000, // Show for 5 seconds
                timerProgressBar: true,
                willClose: () => {
                    setTimeout(() => {
                        navigate("/admin/MemberList"); // Navigate to MemberList page after 5 seconds
                    }, 500);
                }
            });
        } catch (error) {
            console.error('Error submitting form:', error);
        }

        // Clear form data
        // setFormData({
        //     firstName: '',
        //     lastName: '',
        //     email: '',
        //     gender: '',
        //     dob: '',
        //     mobileNumber: '',
        //     testDate: '',
        //     firstTestName: '',
        //     firstTestScore: '',
        //     secondTestName: '',
        //     secondTestScore: '',
        //     note: ''
        // });
        // setJoiningDate('');
        // setMembersTerm('');
        // setLastReneal('');
        // setExpiryDate('');
        // setPresentAddress({
        //     address: '',
        //     pincode: '',
        //     city: '',
        //     state: ''
        // });
        // setPermanentAddress({
        //     address: '',
        //     pincode: '',
        //     city: '',
        //     state: ''
        // });
        // setSameAsPresent(false);
    };


    return (

        //   <div className="page-wrapper">/
        <div className="container mt-4">
            <div className="row mb-3 align-items-center">
                    
                <div className="col-md-6">
                    <button className="cl-back-btn " onClick={() => window.history.back()}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
                        Back
                    </button>
                    <h2>Add New Members</h2>
                </div>

            </div>
            <div className="profile-section">
                {/* Show Chapter Selection only if roleId === 1 */}
                <div className="row" style={{ justifyContent: 'center' }}>
                
                    
                        <div className="col-md-4">
                        <div className="mb-3 form-floating">
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="mobileNumber"
                                        value={formData.mobileNumber}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, ''); // ✅ allow only numbers
                                            setFormData({ ...formData, mobileNumber: value });
                                        }}
                                        onBlur={handleMobileBlur}
                                        placeholder="Mobile Number"
                                    />
                                    <label htmlFor="mobileNumber">
                                        <i className="fa fa-phone"></i> Mobile Number
                                    </label>
                                    {errors.mobileNumber && <p style={{ color: "red" }}>{errors.mobileNumber}</p>}
                                </div>
                                </div>
                                {roleid === 1 && (
                        <div className="col-md-4">
                            <div className="mb-3 form-floating" >
                                <select
                                    className="form-select"
                                    id="chapters"
                                    value={selectedChapter}
                                    onChange={(e) => setSelectedChapter(e.target.value)}
                                    aria-label="Select Chapter"
                                    style={{ borderRadius: "20px" }}
                                >
                                    <option value="" disabled>Select Chapter</option>
                                    {chapters
                                        .filter(term => term.chapter_id !== 1) // 👈 Exclude chapter_id = 1
                                        .map((term) => (
                                            <option key={term.chapter_id} value={term.chapter_id}>
                                                {term.chapter_name}
                                            </option>
                                        ))}
                                </select>
                                <label htmlFor="membersTerm">
                                    <i className="bi bi-file-earmark-person form-icon"></i> Select Chapter
                                </label>
                                {errors.selectedChapter && <p style={{ color: "red" }}>{errors.selectedChapter}</p>}
                            </div>
                        </div>
                        )}
                        <div className="col-md-4">
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="membership_no"
                                    placeholder="Membership No"
                                    value={formData.membership_no}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setFormData({ ...formData, membership_no: value });
                                    }}
                                    onBlur={async () => {
                                        if (!formData.membership_no) return;

                                        try {
                                        const res = await axios.get(
                                            `${baseurl}/admin/check-membership`,
                                            { params: { membership_no: formData.membership_no } }
                                        );

                                        setIsMembershipExists(res.data.exists);
                                        } catch (err) {
                                        console.error(err);
                                        }
                                    }}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    />
                                <label htmlFor="membership_no">
                                <i className="bi bi-person form-icon"></i> Membership No
                                </label>
                                
                            </div>
                            {isMembershipExists && (
                            <small style={{ color: 'red' }}>
                                Membership number already exists
                            </small>
                            )}
                        </div>
                        <hr></hr>
                
                 </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <div className="profile-pic">
                                <img
                                    src={profilePicFile}
                                    alt="add image"
                                    name="images"
                                    className="img-fluid"
                                    style={{objectFit:"fit-height"}}
                                />
                                <i className="fas fa-edit" onClick={handleEditClick}></i>
                                <input
                                    type="file"
                                    id="fileInput"
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        placeholder="First Name"
                                    />
                                    <label htmlFor="firstName">
                                        <i className="fa fa-user"></i> First Name
                                    </label>
                                    {errors.firstName && <p style={{ color: "red" }}>{errors.firstName}</p>}
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        placeholder="Last Name"
                                    />
                                    <label htmlFor="lastName">
                                        <i className="fa fa-user"></i> Last Name
                                    </label>
                                    {errors.lastName && <p style={{ color: "red" }}>{errors.lastName}</p>}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <select
                                        id="gender"
                                        className="form-select"
                                        value={formData.gender}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                    <label htmlFor="gender">Gender</label>
                                    {errors.gender && <p style={{ color: "red" }}>{errors.gender}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="dob">
                                        <i className="fa fa-calendar"></i> Date of Birth
                                    </label>
                                    {errors.dob && <p style={{ color: "red" }}>{errors.dob}</p>}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3 form-floating">
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="mobileNumber"
                                        value={formData.mobileNumber}
                                        onChange={handleChange}
                                        placeholder="Mobile Number"
                                    />
                                    <label htmlFor="mobileNumber">
                                        <i className="fa fa-phone"></i> Mobile Number
                                    </label>
                                    {errors.mobileNumber && <p style={{ color: "red" }}>{errors.mobileNumber}</p>}
                                </div>
                            </div>
                            <div className="col-md-4">

                                <div className="mb-3 form-floating">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email"
                                    />
                                    <label htmlFor="email">
                                        <i className="fa fa-envelope"></i> Email
                                    </label>
                                    {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                                </div>

                            </div>
                        </div>


                    </div>
                </div>

                <div className='row' style={{ top: '40px', position: 'relative' }}>
                    <div className="col-md-6">
                        <div>
                            <h3>Present Address:</h3>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    placeholder="Address"
                                    value={presentAddress.address}
                                    onChange={handlePresentChange}
                                />
                                <label htmlFor="address"><i className="bi bi-house-fill form-icon"></i> Address</label>
                                {errors.presentAddress && <p style={{ color: "red" }}>{errors.presentAddress}</p>}
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="pincode"
                                    placeholder="Pincode"
                                    value={presentAddress.pincode}
                                    onChange={handlePresentChange}
                                />
                                <label htmlFor="pincode"><i className="bi bi-mailbox form-icon"></i> Pincode</label>
                                {errors.presentPincode && <p style={{ color: "red" }}>{errors.presentPincode}</p>}
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    placeholder="City"
                                    value={presentAddress.city}
                                    onChange={handlePresentChange}
                                // readOnly // City field is automatically filled based on pincode
                                />
                                <label htmlFor="city"><i className="bi bi-building-fill form-icon"></i> City</label>
                                {errors.presentCity && <p style={{ color: "red" }}>{errors.presentCity}</p>}
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    placeholder="State"
                                    value={presentAddress.state}
                                    onChange={handlePresentChange}
                                // readOnly // State field is automatically filled based on pincode
                                />
                                <label htmlFor="state"><i className="bi bi-geo-alt-fill form-icon"></i> State</label>
                                {errors.presentState && <p style={{ color: "red" }}>{errors.presentState}</p>}
                            </div>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sameAsPresent"
                                    checked={sameAsPresent}
                                    onChange={handleCheckboxChange}
                                />
                                <label className="form-check-label" htmlFor="sameAsPresent">
                                    Permanent Address Same as Present
                                </label>
                            </div>
                            {error && <p className="text-danger">{error}</p>}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div>
                            <h3>Permanent Address:</h3>

                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    placeholder="Address"
                                    value={permanentAddress.address}
                                    onChange={handlePermanentChange}
                                    disabled={sameAsPresent}
                                />
                                <label htmlFor="address"><i className="bi bi-house-fill form-icon"></i> Address</label>
                                {errors.permanentAddress && <p style={{ color: "red" }}>{errors.permanentAddress}</p>}
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="pincode"
                                    placeholder="Pincode"
                                    value={permanentAddress.pincode}
                                    onChange={handlePermanentChange}
                                    disabled={sameAsPresent}
                                    onBlur={handlePermanentChange} // Fetch city and state based on pincode onBlur
                                />
                                <label htmlFor="pincode"><i className="bi bi-mailbox form-icon"></i> Pincode</label>
                                {errors.permanentPincode && <p style={{ color: "red" }}>{errors.permanentPincode}</p>}
                            </div>

                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    placeholder="City"
                                    value={permanentAddress.city}
                                    onChange={handlePermanentChange}
                                    disabled={sameAsPresent}
                                />
                                <label htmlFor="city"><i className="bi bi-building-fill form-icon"></i> City</label>
                                {errors.permanentCity && <p style={{ color: "red" }}>{errors.permanentCity}</p>}
                            </div>
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    placeholder="State"
                                    value={permanentAddress.state}
                                    onChange={handlePermanentChange}
                                    disabled={sameAsPresent}
                                />
                                <label htmlFor="state"><i className="bi bi-geo-alt-fill form-icon"></i> State</label>
                                {errors.permanentState && <p style={{ color: "red" }}>{errors.permanentState}</p>}
                            </div>
                        </div>
                    </div>
                </div>


                <div className='row' style={{ top: '40px', position: 'relative' }}>
                    <h3>Members Details:</h3>

                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="joiningDate"
                                placeholder="Joining Date"
                                value={joiningDate}
                                onChange={(e) => setJoiningDate(e.target.value)}
                            />
                            <label htmlFor="joiningDate"><i className="bi bi-calendar"></i> Joining Date</label>
                            {errors.joiningDate && <p style={{ color: "red" }}>{errors.joiningDate}</p>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="expiryDate"
                                placeholder="Expiry Date"
                                value={expiryDate}
                                readOnly
                            />
                            <label htmlFor="expiryDate"><i className="bi bi-calendar-check"></i> Expiry Date</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="lastrenewalDate"
                                value={lastrenewalDate}
                                placeholder="Last Renewal"
                                onChange={(e) => setLastReneal(e.target.value)}
                            />
                            <label htmlFor="lastRenewal"><i className="bi bi-calendar-check form-icon"></i> Last Renewal</label>
                            {errors.lastrenewalDate && <p style={{ color: "red" }}>{errors.lastrenewalDate}</p>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <select
                                className="form-select"
                                id="membersTerm"
                                value={selectedTerm}
                                onChange={(e) => setSelectedTerm(e.target.value)}
                                aria-label="Member's Term"
                                style={{ borderRadius: "20px" }}
                            >
                                <option value="" disabled>Select Term</option>
                                {options.map((term) => (
                                    <option key={term.member_status_id} value={term.member_status_id}>
                                        {term.status_name}
                                    </option>
                                ))}
                            </select>
                            <label htmlFor="membersTerm">
                                <i className="bi bi-file-earmark-person form-icon"></i> Member's Term
                            </label>
                            {errors.selectedTerm && <p style={{ color: "red" }}>{errors.selectedTerm}</p>}
                        </div>
                    </div>

                </div>


                <div className="row" style={{ paddingTop: '80px', position: 'relative' }}>
                    <h3>Test Details:</h3>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="date" className="form-control" id="testDate"  value={formData.testDate} onChange={handleChange} placeholder="Test Date" />
                            <label htmlFor="testDate"><i className="bi bi-calendar"></i> Test Date</label>
                            {errors.testDate && <p style={{ color: "red" }}>{errors.testDate}</p>}
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="firstTestScore" value={formData.firstTestScore} onChange={handleChange} placeholder="First Test Score" />
                            <label htmlFor="firstTestScore"><i className="bi bi-clipboard-check"></i> First Test Score</label>
                            {errors.firstTestScore && <p style={{ color: "red" }}>{errors.firstTestScore}</p>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="firstTestName" value={formData.firstTestName} onChange={handleChange} placeholder="First Test Name" />
                            <label htmlFor="firstTestName"><i className="bi bi-file-earmark-text"></i> First Test Name</label>
                            {errors.firstTestName && <p style={{ color: "red" }}>{errors.firstTestName}</p>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="secondTestScore" value={formData.secondTestScore} onChange={handleChange} placeholder="Second Test Score" />
                            <label htmlFor="secondTestScore"><i className="bi bi-clipboard-check"></i> Second Test Score</label>
                            {errors.secondTestScore && <p style={{ color: "red" }}>{errors.secondTestScore}</p>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mb-3 form-floating">
                            <input type="text" className="form-control" id="secondTestName" value={formData.secondTestName} onChange={handleChange} placeholder="Second Test Name" />
                            <label htmlFor="secondTestName"><i className="bi bi-file-earmark-text"></i> Second Test Name</label>
                            {errors.secondTestName && <p style={{ color: "red" }}>{errors.secondTestName}</p>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-12">
                            <div className="mb-3 form-floating">
                                <textarea
                                    className="form-control"
                                    id="note"
                                    rows="3"
                                    value={formData.note}
                                    onChange={handleChange}
                                ></textarea>
                                <label htmlFor="note">Note</label>
                            </div>
                        </div>
                    </div>
                    <div className='row' style={{ paddingTop: '80px', position: 'relative', display:'flex' }}>
                        <div className='col-md-6 col-sm-6' style={{textAlign: 'right'}}>
                            <button className='btn btn-danger'>
                                 <Link to="/admin/MemberList" style={{color:'white'}}>Cancel</Link>
                            </button>
                        </div>
                        <div className='col-md-6 col-sm-6' >
                            <button type="submit" style={{borderRadius:'8px'}} onClick={handleSubmit}>Submit</button>
                        </div>
                        
                    </div>
                </div>


            </div>
        </div>
        // </div>

    );
};

export default MemberForm;
